// This card exists only in the visitor's feed buffer. It is not a publication,
// author account, analytics view or a parent opinion for influence statistics.
export const UNSUBSCRIBE_CARD_ID = -1000;
const copy = {
  en: ['Your opponents won’t miss you.', 'Move the slider. Have your say.'],
  ru: ['Ваши оппоненты скучать не будут.', 'Двигайте слайдер. Выскажите своё мнение.'],
  es: ['Tus oponentes no te echarán de menos.', 'Mueve el control deslizante. Da tu opinión.'],
  fr: ['Vous ne manquerez pas à vos adversaires.', 'Déplacez le curseur. Donnez votre avis.'],
  de: ['Deine Gegner werden dich nicht vermissen.', 'Bewege den Regler. Sag deine Meinung.'],
  it: ['Ai tuoi avversari non mancherai.', 'Sposta il cursore. Di’ la tua.'],
  pt: ['Seus oponentes não vão sentir sua falta.', 'Mova o controle deslizante. Dê sua opinião.'],
  tr: ['Karşıt görüştekiler seni özlemeyecek.', 'Kaydırıcıyı hareket ettir. Fikrini söyle.'],
  zh: ['你的对手不会想念你。', '移动滑块，表达你的观点。'],
  ja: ['反対派は、あなたがいなくても寂しくありません。', 'スライダーを動かして、意見を伝えよう。'],
  ko: ['반대편 사람들은 당신을 그리워하지 않을 거예요.', '슬라이더를 움직여 의견을 표현하세요.'],
  hi: ['आपके विरोधियों को आपकी कमी नहीं खलेगी।', 'स्लाइडर खिसकाएँ। अपनी राय रखें।'],
};
const html = lines => lines.map(line => `<p>${line}</p>`).join('');
export const unsubscribeCopy = language => Object.prototype.hasOwnProperty.call(copy, language) ? copy[language] : copy.en;
export function unsubscribeCard(response, storyId = null) {
  if (!response?.success || !Number.isSafeInteger(response.story?.id) || response.story.id <= 0
    || typeof response.story.title !== 'string') return null;
  const translated = unsubscribeCopy(response.language);
  return { id: UNSUBSCRIBE_CARD_ID, system: 'unsubscribe', story: response.story,
    user: { id: 0, first_name: 'WIW', last_name: '', user_name: 'wiw', picture: null },
    scope: 4, language: 'en', landing_language: response.language, landing_story_id: storyId, text_msg: html(copy.en),
    text_msg_translation: response.language !== 'en' ? html(translated) : null,
    geolocation: ['iplocate', 'db-ip'].includes(response.geolocation) ? response.geolocation : null, viewed: true };
}
